export interface Referral {
    _id: string;
    status: ReferralStatus;
    created: Date;
    updated?: Date;
    deleted?: Date;
    referralType?: ReferralType;
}

export enum ReferralType {
    Order = 'order',
    Content = 'content'
}

export enum ReferralStatus {
    Pending = 'pending',
    Opened = 'opened',
    SignupStarted = 'signupStarted',
    SignupCompleted = 'signupCompleted'
}

export interface SelectedOrganization {
    _id: string;
    name: string;
    address: {
        line1: string;
        city: string;
        zip: string;
    };
    type: string;
}

export enum ReferralStatusCode {
    EXPIRED = 'expired',
    INVALID = 'invalid',
    ERROR = 'error'
}

export enum SignupErrorType {
    UserAlreadyExistsError = 'UserAlreadyExistsError',
    ValidationError = 'ValidationError',
    SignupRequestAlreadyExistsError = 'SignupRequestAlreadyExistsError',
    SignupRequestNotFoundError = 'SignupRequestNotFoundError',
    InvitationAlreadyExistsError = 'InvitationAlreadyExistsError',
    InvitationUsedError = 'InvitationUsedError',
    InvitationExpiredError = 'InvitationExpiredError',
    InvalidInvitationCodeError = 'InvalidInvitationCodeError',
    InvalidReferralIdError = 'InvalidReferralIdError',
    UnknownError = 'UnknownError'
}
